import { makeRequest } from '@/base/MaRequestPooler'

/**
 *
 * @param {object} data
 * @param {Sting} data.page - Target page route
 * @param {object} data.pageParams - Target page custom data
 * @param {string} data.fileName - Pdf file name
 * @returns {Promise<object>}
 */
export function generate(data) {
  return makeRequest(`/pdf-reports`, {
    method: 'POST',
    data,
  })
}

export function checkStatus(reportId) {
  return makeRequest(`/pdf-reports/${reportId}/status`)
}

export function getFileBlob(reportId) {
  return makeRequest(`/pdf-reports/${reportId}/file`, {
    responseType: 'arraybuffer',
    headers: {
      Accept: 'application/pdf',
    },
  })
}

export function remove(reportId) {
  return makeRequest(`/pdf-reports/${reportId}`, { method: 'DELETE' })
}
